export default __webpack_public_path__ + "static/media/chevron-down-light.6f412294.svg";